import { createAsyncThunk } from '@reduxjs/toolkit'
import RestClient from '../../../../services/client/RestClient'
import { isNotEmpty } from '../../../../utils/helpers'
import Configuration from '../../../../services/api/Configuration'
import SystemAdminUsers from '../../../../services/api/SystemAdminUsers'

const { SystemAdminUsers_Endpoints } = SystemAdminUsers
const getCompaniesLookupApi = Configuration.Company_Endpoints

const resetState = {
  pageNumber: 0,
  activeFilters: [],
  activeSearch: '',
  updatedItem: {},
}
export const systemAdminUsersResetAlertHandler = createAsyncThunk(
  'systemAdminUsers/systemAdminUsersResetAlertHandler',
  async () => ({}),
)

export const retrieveSystemAdminUsers = createAsyncThunk(
  'systemAdminUsers/retrieveSystemAdminUsers',
  async ({ queries, resetQueries }, { getState, rejectWithValue }) => {
    const apiUri = SystemAdminUsers_Endpoints();
    const { systemAdminUsers } = getState()
    const endpoint = apiUri.list;
    const queryString = createReqHelper(systemAdminUsers, resetQueries ? resetState : queries)
    const response = await RestClient.getRequest(`${endpoint}?${queryString}`);
    if (response.status >= 300) {
      return rejectWithValue(response);
    }

    return {
      response: response.data,
      queries: resetQueries ? resetState : queries,
    };
  },
)

export const filterSystemAdminUsers = createAsyncThunk(
  'systemAdminUsers/filterSystemAdminUsers',
  async ({ queries }, { getState, rejectWithValue }) => {
    const { systemAdminUsers } = getState()
    const apiUri = SystemAdminUsers_Endpoints()
    let newFilterObj = { ...systemAdminUsers?.activeFilters }

    if (queries === 'clear') {
      newFilterObj = {
        userTypes: [],
        companies: [],
        subscriptionReminder: [],
      }
    } else if (queries?.userTypes || queries?.companies) {
      newFilterObj = { ...newFilterObj, ...queries }
    } else if (Array.isArray(queries)) {
      newFilterObj = { ...newFilterObj, userTypes: queries }
    } else {
      newFilterObj = removeFilterIfExist(systemAdminUsers?.filterList, queries, newFilterObj)
    }

    const filters = createReqHelper(systemAdminUsers, {
      activeFilters: newFilterObj,
      pageNumber: 0,
    })

    const response = await RestClient.getRequest(
      `${apiUri.list}?${filters}`,
    )
    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return {
      response: response.data,
      queries: {
        activeFilters: newFilterObj,
        pageNumber: 0,
      },
    }
  },
)
export const updateTenantID = createAsyncThunk(
  'systemAdminUsers/updateTenantID',
  async ({ queries }) => queries,
)

export const resetUserPasswordRequest = createAsyncThunk(
  'systemAdminUsers/resetUserPasswordRequest',
  async ({ queries }) => {
    const apiUri = SystemAdminUsers_Endpoints(queries.data.id)
    const response = await RestClient.postRequest(
      apiUri.resetPasswordRequest,
    )
    return response.data
  },
)

export const systemAdminUsersChangeStatus = createAsyncThunk(
  'systemAdminUsers/systemAdminUsersChangeStatus',
  async ({ queries }) => {
    const { title } = queries
    const isActive =
      title === 'Active' || title === 'ActiveUser'
    const isDisabled =
      title === 'Disabled' || title === 'DisabledUser'
    let body
    if (isActive) body = { active: true }
    else if (isDisabled) body = { active: false }
    const apiUri = SystemAdminUsers_Endpoints(queries.data.id)
    const endpoint = apiUri.getUserId
    const response = await RestClient.putRequest(endpoint, body)
    return response.data
  },
)

export const updateSelectedSystemAdminUserStore = createAsyncThunk(
  'systemAdminUsers/updateSelectedSystemAdminUserStore',
  async ({ queries }) => queries,
)

export const retrieveSystemAdminUserByID = createAsyncThunk(
  'systemAdminUsers/retrieveSystemAdminUserByID',
  async ({ queries }) => {
    const apiUri = SystemAdminUsers_Endpoints(queries.id)
    const res = await RestClient.getRequest(apiUri.getUserId)
    return res.data
  },
)

export const createSystemAdminUsers = createAsyncThunk(
  'systemAdminUsers/createSystemAdminUsers',
  async ({ queries }, { rejectWithValue, getState }) => {
    const titleId = { title_id: queries.updatedUser?.title?.id }
    let employee = null

    if (isNotEmpty(queries.updatedUser.employee)) {
      employee = {
        code: queries.updatedUser.employee,
        departments: queries.updatedUser.departments,
      }
    }

    const updatedUserClone = { ...queries.updatedUser }
    delete updatedUserClone.title

    const newQuery = {
      ...updatedUserClone,
      ...titleId,
      employee: queries.updatedUser.employee?.id ? queries.updatedUser.employee : employee,
    }

    const apiUri = SystemAdminUsers_Endpoints()
    const res = await RestClient.postRequest(`${apiUri.list}`, newQuery, {
      headers: {
        tenant_id: newQuery.tenant_id,
      },
    })

    if (res.status >= 300) {
      return rejectWithValue(res)
    }

    const { language } = getState()

    return {
      severity: 'success',
      message: language?.translations?.['User has been added successfully'],
    }
  },
)

export const editSystemAdminUser = createAsyncThunk(
  'systemAdminUsers/editSystemAdminUser',
  async ({ queries }, { rejectWithValue, getState }) => {
    const titleId = { title_id: queries.updatedUser?.title?.id }
    let employee = null
    const apiUri = SystemAdminUsers_Endpoints(queries.updatedUser.id)
    const endpoint = apiUri.getUserId

    if (isNotEmpty(queries.updatedUser.employee)) {
      employee = {
        code: queries.updatedUser.employee,
        departments: queries.updatedUser.departments,
      }
    }

    const updatedUserClone = { ...queries.updatedUser }
    delete updatedUserClone.title

    const pr = updatedUserClone.subscription_reminder
    const subscription_reminder = {
      reminder: !!pr?.reminder,
      en_message: pr?.en_message || '',
      ar_message: pr?.ar_message || '',
    }

    const newQuery = {
      ...updatedUserClone,
      ...titleId,
      subscription_reminder,
      employee: queries.updatedUser.employee?.id ? queries.updatedUser.employee : employee,
    }

    const res = await RestClient.putRequest(endpoint, newQuery, {
      headers: {
        tenant_id: queries.updatedUser.tenant_id,
      },
    })

    if (res.status >= 300) {
      return rejectWithValue(res)
    }

    const { language } = getState()

    return {
      severity: 'success',
      message: language?.translations?.['User has been updated successfully'],
    }
  },
)

export const retrieveSystemAdminUsersCompanies = createAsyncThunk(
  'systemAdminUsers/retrieveSystemAdminUsersCompanies',
  async (_, { rejectWithValue }) => {
    const response = await RestClient.getRequest(`${getCompaniesLookupApi.lookup}`)
    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response.data
  },
)
function removeFilterIfExist(filterListObj, queries, activeFilters) {
  if (filterListObj?.userTypes?.some((e) => e.name === queries.name) === true) {
    activeFilters.userTypes = activeFilters?.userTypes?.filter(
      (user_type) => user_type.id !== queries.id,
    )
  } else if (filterListObj?.companies?.some((e) => e.name === queries.name) === true) {
    activeFilters.companies = activeFilters?.companies?.filter(
      (company_id) => company_id.id !== queries.id,
    )
  } else if (filterListObj?.subscriptionReminder?.some((e) => e.name === queries.name) === true) {
    activeFilters.subscriptionReminder = activeFilters?.subscriptionReminder?.filter(
      (subscription_reminder) => subscription_reminder.id !== queries.id,
    )
  }
  return activeFilters
}

function createReqHelper(store, filters = {}) {
  const copyStore = { ...store, ...filters };

  const activeFilters = copyStore.activeFilters || {};
  const getFilterIds = (filtersId) => {
    if (!filtersId) return []
    if (Array.isArray(filtersId)) return filtersId.map((filter) => filter.id)
    return [filtersId.id]
  }

  const filterUserTypeIds = getFilterIds(activeFilters?.userTypes).join('&user_types=')
  const filterCompanyIds = getFilterIds(activeFilters?.companies).join('&company_ids=')
  const filterSubscriptionReminderIds = getFilterIds(activeFilters?.subscriptionReminder).join('&subscription_reminder_status=')

  const {
    pageSize,
    pageNumber,
    activeSort,
    activeSearch,
    activeSummary,
  } = copyStore;

  return [
    `page_number=${pageNumber || 0}`,
    `page_size=${pageSize || 9}`,
    `sort_by=${activeSort?.key || ''}`,
    `data_status=${activeSummary || ''}`,
    `user_types=${filterUserTypeIds}`,
    `company_ids=${filterCompanyIds}`,
    `search=${activeSearch || ''}`,
    `subscription_reminder_status=${filterSubscriptionReminderIds}`,
  ].join('&');
}
